package org.zq.astrock_ai.ui.research.gushi.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.zq.astrock_ai.storage.ResearchKvStorage
import org.zq.astrock_ai.util.currentTimeMillis

@Serializable
data class BrowseHistoryItem(
    val code: String,
    val name: String = "",
    val atMs: Long = 0L,
)

@Serializable
private data class BrowseHistoryFile(
    val version: Int = 1,
    val items: List<BrowseHistoryItem> = emptyList(),
)

object BrowseHistoryStore {
    private const val KEY = "browse.history.v1"
    private const val MAX_ITEMS = 80
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = true
    }

    fun load(): List<BrowseHistoryItem> = runCatching {
        val raw = ResearchKvStorage.get(KEY) ?: return emptyList()
        json.decodeFromString<BrowseHistoryFile>(raw).items
            .filter { it.code.length == 6 }
            .distinctBy { it.code }
            .take(MAX_ITEMS)
    }.getOrDefault(emptyList())

    fun prepend(code: String, name: String): List<BrowseHistoryItem> {
        val normalized = code.filter { it.isDigit() }.takeLast(6)
        if (normalized.length != 6) return load()
        val item = BrowseHistoryItem(
            code = normalized,
            name = name.ifBlank { normalized },
            atMs = currentTimeMillis(),
        )
        val next = (listOf(item) + load().filter { it.code != normalized }).take(MAX_ITEMS)
        save(next)
        return next
    }

    fun remove(code: String): List<BrowseHistoryItem> {
        val normalized = code.filter { it.isDigit() }.takeLast(6)
        val next = load().filter { it.code != normalized }
        save(next)
        return next
    }

    private fun save(items: List<BrowseHistoryItem>) {
        ResearchKvStorage.put(KEY, json.encodeToString(BrowseHistoryFile(items = items)))
    }
}
